import { MaterialAmountGetRequest } from '@dave/types';
import { createAction, props } from '@ngrx/store';
import { MaterialAmountEntity } from '../../entities/material-amount.entity';
import { GatewayResponseErrorType } from '../../services/app-gateway.service';

const prefix = 'data/' + 'materialAmount/';
export const MaterialAmountActionTypes = {
    Load: createAction(prefix + 'load', props<{ Payload: MaterialAmountGetRequest }>()),
    // Change: createAction(prefix + 'change', props<{ Payload: MaterialAmount }>()),
    // Delete: createAction(prefix + 'delete', props<{ Payload: MaterialGroupTypeDeleteRequest }>()),

    UpdateAll: createAction(prefix + 'updateAll', props<{ Payload: Array<MaterialAmountEntity>; updateLatestUpdatedAt?: boolean }>()),
    UpdateMany: createAction(prefix + 'updateMany', props<{ Payload: Array<MaterialAmountEntity>; updateLatestUpdatedAt?: boolean }>()),
    // UpdateOne: createAction(prefix + 'updateOne', props<{ Payload: MaterialAmountEntity }>()),
    // RemoveOne: createAction(prefix + 'remove', props<{ Payload: number }>()),

    LoadRequest: createAction(prefix + 'load/request', props<{ Payload: MaterialAmountGetRequest }>()),
    LoadSuccess: createAction(prefix + 'load/success', props<{ Payload: MaterialAmountEntity[] }>()),
    LoadFailure: createAction(prefix + 'load/failure', props<{ Payload: { Errors: GatewayResponseErrorType; ToasterMessage?: string } }>()),
};
